module.exports = __webpack_public_path__ + "static/media/BuenosAiresWeb-Bold.df6bdda5.woff";